var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "ea80a6cce3a6e28f67f41e16b4eebe291dc51217"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["client-dashboard@hr-go-plc"] = {
  id: "ea80a6cce3a6e28f67f41e16b4eebe291dc51217"
};